/*
 * @Author: 哎呦先生 392632962@qq.com
 * @Date: 2024-01-23 10:49:01
 * @LastEditors: 哎呦先生 392632962@qq.com
 * @LastEditTime: 2024-01-23 15:15:58
 * @FilePath: \官网\src\compoment\news.jsx
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import React from 'react';
import TweenOne from 'rc-tween-one';
import { Avatar, List, Image } from 'antd';
import { enquireScreen } from 'enquire-js';
const data = [
    {
        title: 'Ant Design Title 1',
    },
    {
        title: 'Ant Design Title 2',
    },
    {
        title: 'Ant Design Title 3',
    },
    {
        title: 'Ant Design Title 4',
    },
];

let isMobile;
enquireScreen((b) => {
    isMobile = b;
    // console.log(isMobile);
});



class News extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile,

        };
    }


    componentDidMount () {
        console.log(2222, this.props.data);
        const urlParams = new URL(window.location.href);
        enquireScreen((b) => {

            this.setState({ isMobile: b });
            console.log(11111, this.state.isMobile);
        });




    }

    toPdf = (url) => {
        const w = window.open('about:blank');
        w.location.href = url
    }
    render () {
        let children = this.state.isMobile ?
            <List
                itemLayout="vertical"
                dataSource={this.props.data}
                renderItem={(item) => (
                    <List.Item>
                        <div>
                            <Image
                                width={'100%'}
                                preview={false}
                                src={item.img}
                            />

                        </div>
                        <p style={{ marginTop: '16px' }}><a className="newstitle" onClick={() => { this.toPdf(item.url) }}>{item.title}</a></p>
                        <p className='newsmsg' >{item.msg}</p>
                        <div style={{ textAlign: 'end', color: '#666' }}><span>{item.date}</span></div>
                    </List.Item >
                )
                }
            /> : <List
                itemLayout="horizontal"
                dataSource={this.props.data}
                style={{ marginLeft: '19%', marginRight: '19%' }}
                renderItem={(item) => (
                    <List.Item >

                        <List.Item.Meta
                            avatar={<Image
                                width={200}
                                height={120}
                                src={item.img}
                            />}
                            title={<a className="newstitle" onClick={() => { this.toPdf(item.url) }}>{item.title}</a>}
                            description={item.msg}
                        />
                        <span style={{ alignSelf: 'flex-start' }}>{item.date}</span>
                    </List.Item>
                )}
            />
        return (

            <div style={this.props.style}>
                {children}
            </div>


        );
    }
}

export default News;
